<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uWMWe8/tc-custom/9781504093446.jpg?1734667216037" alt="This image is the cover for the book Monk Swimming"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monk Swimming
      </h1>
      <p class="bookDescription body article font2">
        <b>In this “irresistible memoir that’s equal parts pathos and belly laughs,” the Irish American writer and actor shares stories from his first decade in the US (<i>People</i>).</b><br/><br/> Malachy McCourt left behind a childhood of poverty and painful memories of his father and mother in Limerick, Ireland, when he followed his brother, Frank, to America in 1952.<br/><br/> In <i>A Monk Swimming</i>, McCourt recounts the decade that followed. With not much to his name other than his sharp wit and knack for storytelling, McCourt was unsure what he would do after arriving in New York City. He worked as a longshoreman on the Brooklyn docks, became the first celebrity bartender in a Manhattan saloon, performed on stage with the Irish Players, and told tales to Jack Paar on <i>The Tonight Show</i>.<br/><br/> Although McCourt gained success, money, women, and, eventually, children of his own, he still carried memories of the past with him. So, he fled again. He found himself in the Manhattan Detention Complex, otherwise known as the Tombs. He was arrested several times: poolside in Beverly Hills, in Zurich with gold-smugglers, and again in Calcutta with sex workers. McCourt’s journey also took him to Paris, Rome, and even Limerick again, until finally he was forced to grapple with his past.<br/><br/> “[A] funny, oddly winning book.” —<i>The New York Times</i><br/><br/> “A rollicking good read that, as the Irish say, would make a dead man laugh.” —<i>The Philadelphia Inquirer</i><br/><br/> “A triumphant tale. . . . You will find yourself laughing through the tears.” —<i>Newsday</i><br/><br/> “Howlingly funny.” —<i>Atlanta Journal-Constitution</i><br/><br/> “Build[s] on the story of the McCourts’ early life so dazzlingly told in <i>Angela’s Ashes</i> by his brother Frank.” —Thomas Keneally, author of the international bestseller<i>Schindler’s List</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malachy McCourt
      </h2>
      
      <p class="authorDescription body article"> Malachy McCourt was the author of <I>A Monk Swimming</I>. Born in 1931 in Brooklyn, New York, he was raised in Limerick, Ireland. He returned to New York in 1952 at the age of twenty, which is where his memoir begins. A quintessential Upper West Sider, organizer, and stalwart of Bloomsday at Symphony Space, McCourt was awarded the Irish American Writers and Artists (IAMWA) Eugene O&rsquo;Neill Lifetime Achievement Award in 2016. <I>The Irish Echo </I>designated him &ldquo;The Great Sennachie.&rdquo; He was the first to admit he could not have accomplished any of this but for the love and support of his wife, Diana, who he was outrageously lucky to find and charm, and keep amused for more than fifty years. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Welcome Rain Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?112d2a7f